import React from 'react';
import { useState, useRef } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Stack, Col, Row } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import Alert from '../helper/Alert';

import {
    email,
    subject
} from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

const schema = yup.object().shape({
    receiver: email,
    subject: subject,
});

function Invite() {
    const { request } = useRequest();

    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);

    const sendInvitation = async (values) => {
        setLoading(true);
        const result = await request("/Mailing/SendInvite", values);
        const json = result.data;

        setLoading(false);
        if (json.r == 1) {
            toast.success("Einladung wurde erfolgreich versandt.");
        }
        else {
            setMessage(json.message);
        }
    }

    return (
        <Formik
            innerRef={(f) => (formRef.current = f)}
            validationSchema={schema}
            onSubmit={(values) => {
                sendInvitation(values);
            }}
            initialValues={{
                receiver: '',
                subject: 'Einladung bovest Registrierung',
                message: '',
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => {

                return (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Stack gap={2}>
                            {message && <Alert type="error" message={message} />}
                            <Form.Group as={Row} className="mb-3" controlId="receiver">
                                <Form.Label className="required" column sm={3}>Empfänger</Form.Label>
                                <Col sm={9}>
                                    <Form.Control isInvalid={errors.receiver && touched.receiver} type="email" name="receiver" value={values.receiver} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.receiver}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="subject">
                                <Form.Label className="required" column sm={3}>Betreff</Form.Label>
                                <Col sm={9}>
                                    <Form.Control isInvalid={errors.subject && touched.subject} type="text" name="subject" value={values.subject} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.subject}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" controlId="message">
                                <Form.Label column sm={3}>Nachricht</Form.Label>
                                <Col sm={9}>
                                    <Form.Control isInvalid={errors.message && touched.message} as="textarea" rows={8} name="message" value={values.message} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.message}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>
                            <Button disabled={loading} variant="secondary" type="submit">
                                <i className="fa-solid fa-check mr-2"></i>Einladung versenden
                            </Button>
                        </Stack>

                        <MandatoryFieldNotice />
                    </Form>
                )
            }}
        </Formik>
    )
}

export default Invite;